import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Questionnarie } from '../models/questionnarie.model';
import { Filter } from '../models/filter.model';

@Injectable({
    providedIn: 'root'
})
export class QuestionnariesService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/questionnaires/' + id).toPromise();
    }

    getTotal(filter: Filter) {
        return this.httpClient.post('api/questionnaires/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res.total;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    gridView(filter: Filter) {
        return this.httpClient.post('api/questionnaires/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createQuestionnarie(question: Questionnarie) {
        return this.httpClient.post('api/questionnaires/create', question.data).toPromise();
    }

    editQuestionnarie(question: Questionnarie) {
        return this.httpClient.post('api/questionnaires/edit', question.data).toPromise();
    }

    deleteQuestionnarie(ids: Array<Number>) {
        return this.httpClient.post('api/questionnaires/delete', ids).toPromise();
    }

}